module.exports = __webpack_public_path__ + "img/medical_diwu.49df481f.png";